import { render } from "./CourseInfoModal.vue?vue&type=template&id=7c4e1e28&scoped=true"
import script from "./CourseInfoModal.vue?vue&type=script&lang=js"
export * from "./CourseInfoModal.vue?vue&type=script&lang=js"

import "./CourseInfoModal.vue?vue&type=style&index=0&id=7c4e1e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4e1e28"]])

export default __exports__